import styled from 'styled-components';

export const ToolContainer = styled.div`
  // background-image: linear-gradient(to bottom, #e5e7e766, #fff);
  background: #fff;
  padding: 2em 0 3em;

  @media (max-width: 720px) {
    padding: ${(props) => (props.ovulation ? '0 0 3em' : '2em 0 3em')};
  }
`;

export const ToolWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.gridCount}, 1fr);
  text-align: center;
  padding-top: 2.5em;

  & div {
    margin: 8px 0;
  }

  @media (max-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
    padding-top: 0;
  }
`;

export const Toollist = styled.div`
  background: ${(props) => props.color};
  transition: all 0.5s ease;
  &:hover {
    transform: scale(1.08);
  }
  border-radius: 50%;
  width: 137px;
  display: inline-block;
  height: 137px;
  cursor: pointer;

  @media (max-width: 720px) {
    cursor: default;
    width: 100px;
    height: 100px;
  }
`;

export const ToolImage = styled.img`
  position: relative;
  top: 50%;
  transform: translate(0, -50%);
  width: 70px;
  @media (max-width: 720px) {
    width: 50px;
  }
`;

export const ToolName = styled.p`
  color: #000;
  font-weight: 600;
  padding-top: 10px;
  opacity: 0.78;
  font-size: 14px;
`;

export const AllToolsContainer = styled.div`
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const ViewAll = styled.div`
  width: 137px;
  height: 137px;
  display: inline-flex;
  background: #cfcfcf;
  color: #0000008a;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  font-size: 2.4em;
  font-weight: 600;

  @media (max-width: 720px) {
    width: 100px;
    height: 100px;
    font-size: 2em;
  }
`;
